/*las entradas de menu que no tiene subentradas deben tener roles, si tienen subentradas los roles se especifican
en las subentradas */
//el rol '*' significa que es accesible por todos los roles
const Menu = [
    {
        title: "Escritorio",
        group: "apps",
        icon: "fa fa-home",
        name: "Dashboard",
        roles: "*"
    },
    { header: "Administración" },
    {
        title: "Usuario",
        group: "apps",
        icon: "fa fa-user",
        name: "usuario",
        component: "usuario",
        roles: ["superadmin", "admin"]
    },

    {
        title: "Historial",
        group: "apps",
        icon: "fa-archive",
        name: "historial",
        component: "historial",
        roles: ["superadmin", "admin"]
    },

    /*{
        title: "Gestionar notificaciones",
        group: "apps",
        icon: "fa-bell",
        name: "adm-notificacion",
        component: "adm-notificacion",
        roles: ["superadmin", "admin"]
    },

    {
        title: "Notificación",
        group: "apps",
        icon: "fa-bell",
        name: "user-notificacion",
        component: "notificacion",
        roles: ["superadmin", "admin", "rrhh_supervisor", "finanzas_supervisor", "rrhh_asistente", "finanzas_asistente"]
    },*/

    //por ahora no se van a utilizar la tareas
    /*{
        title: "Gestionar tareas",
        group: "apps",
        icon: "fa-list-ul",
        name: "adm-tarea",
        component: "tarea",
        roles: ["superadmin", "admin", "rrhh_supervisor", "finanzas_supervisor"]
    },

    {
        title: "Tarea",
        group: "apps",
        icon: "fa-list-ul",
        name: "user-tarea",
        component: "tarea",
        roles: ["superadmin", "admin", "rrhh_supervisor", "finanzas_supervisor", "rrhh_asistente", "finanzas_asistente"]
    },*/

    {
        title: "Estadísticas",
        group: "apps",
        icon: "fa fa-bar-chart",
        name: "empleado-estadisticas",
        component: "empleado-estadisticas",
        roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
    },
    { header: "Personal" },
    {
        title: "Colaborador",
        group: "apps",
        icon: "fa fa-group",
        name: "empleado",
        component: "empleado",
        roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
    },
    {
        title: "Asistencia",
        group: "personal",
        icon: "fa fa-check-square",
        name: "asistencia",
        component: "asistencia",
        roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
    },
    {
        title: "Prenómina",
        group: "personal",
        icon: "fa-money",
        name: "nomina",
        component: "nomina",
        roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
    },
    { header: "Finanzas" },
    {
        title: "Activo fijo",
        group: "apps",
        icon: "fa-pencil",
        name: "activo",
        component: "activo",
        roles: ["finanzas_asistente", "finanzas_supervisor"]
    },
    {
        title: "Solicitud de pago",
        group: "apps",
        icon: "fa-dollar",
        name: "solicitudes-pago",
        component: "solicitudes-pago",
        roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
    },
    {
        title: "Montos",
        group: "apps",
        icon: "fa-bar-chart",
        name: "solicitud-pago-stats",
        component: "solicitudes-pago-stats",
        roles: ["admin", "finanzas_supervisor"]
    },
    { header: "Cobranza" },
    {
        title: "Estudiante",
        group: "apps",
        icon: "fa-graduation-cap",
        name: "estudiante",
        component: "estudiante",
        roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
    },
    { header: "Nomencladores" },
    {
        title: "Personal",
        group: "nomenclators",
        icon: "fa fa-cog",
        items: [
            {
                title: "Campus",
                group: "nomenclators",
                href: "#/nomencladores/campus",
                component: "campus",
                roles: ["admin", "rrhh_supervisor"]
            },
            {
                title: "Departamento",
                group: "nomenclators",
                href: "#/nomencladores/departamento",
                component: "departamento",
                roles: ["admin", "rrhh_supervisor"]
            },
            {
                title: "Puesto",
                group: "nomenclators",
                href: "#/nomencladores/puesto",
                component: "puesto",
                roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
            },
            {
                title: "Escolaridad",
                group: "nomenclators",
                href: "#/nomencladores/escolaridad",
                component: "escolaridad",
                roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
            },
            {
                title: "Estado civil",
                group: "nomenclators",
                href: "#/nomencladores/estado-civil",
                component: "estado-civil",
                roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
            },
            {
                title: "Género",
                group: "nomenclators",
                href: "#/nomencladores/sexo",
                component: "sexo",
                roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
            },
            {
                title: "Título",
                group: "nomenclators",
                href: "#/nomencladores/titulo",
                component: "titulo",
                roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
            },
            /*{
                title: "Motivo Baja",
                group: "nomenclators",
                href: "#/nomencladores/motivo-baja",
                component: "motivo-baja",
                roles: ["admin", "rrhh_asistente", "rrhh_supervisor"]
            }*/
        ]
    },
    {
        title: "Finanzas",
        group: "nomenclators",
        icon: "fa fa-cog",
        items: [
            {
                title: "Banco",
                group: "nomenclators",
                href: "#/nomencladores/banco",
                component: "banco",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Concepto",
                group: "nomenclators",
                href: "#/nomencladores/concepto",
                component: "concepto",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Forma de Pago",
                group: "nomenclators",
                href: "#/nomencladores/forma-pago",
                component: "forma-pago",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Tipo de Monto",
                group: "nomenclators",
                href: "#/nomencladores/tipo-monto",
                component: "tipo-monto",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Activo categoría",
                group: "nomenclators",
                href: "#/nomencladores/activo-categoria",
                component: "activo-categoria",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Activo estado",
                group: "nomenclators",
                href: "#/nomencladores/activo-estado",
                component: "activo-estado",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Activo tipo",
                group: "nomenclators",
                href: "#/nomencladores/activo-tipo",
                component: "activo-tipo",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Activo grupo",
                group: "nomenclators",
                href: "#/nomencladores/activo-grupo",
                component: "activo-grupo",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Área",
                group: "nomenclators",
                href: "#/nomencladores/area",
                component: "area",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Edificio",
                group: "nomenclators",
                href: "#/nomencladores/edificio",
                component: "edificio",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Solicitud Pago categoría",
                group: "nomenclators",
                href: "#/nomencladores/solicitud-pago-categoria",
                component: "solicitud-pago-categoria",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            }
        ]
    },
    {
        title: "Cobranza",
        group: "nomenclators",
        icon: "fa fa-cog",
        items: [
            {
                title: "Tutor",
                group: "nomenclators",
                href: "#/tutor",
                component: "tutor",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Grado",
                group: "nomenclators",
                href: "#/nomencladores/grado",
                component: "grado",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Tipo de Ciclo",
                group: "nomenclators",
                href: "#/nomencladores/ciclo",
                component: "ciclo",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Tipo de Financiamiento",
                group: "nomenclators",
                href: "#/nomencladores/tipo-financiamiento",
                component: "tipo-financiamiento",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Tipo de sangre",
                group: "nomenclators",
                href: "#/nomencladores/tipo-sangre",
                component: "tipo-sangre",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            },
            {
                title: "Servicio médico",
                group: "nomenclators",
                href: "#/nomencladores/servicio-medico",
                component: "servicio-medico",
                roles: ["admin", "finanzas_asistente", "finanzas_supervisor"]
            }
        ]
    }
]
export default Menu
